import { postDeleteAudience } from '../services';
export const deleteAudience = (params) => postDeleteAudience(params).then(response => formatResponse(response?.data));
const formatResponse = (response) => {
    return response?.success;
};
